import { put, call, select } from 'redux-saga/effects'
import Actions from '../stores/workflows/actions';
import Api from '../api/api'
import GeneralActions from '../stores/general/actions';

export function* loadWorkflow({wid}: any) {
  try {
    const response = yield call(Api.getWorkflowDetails, wid);
    yield put(Actions.loadWorkflowSuccess(response));
  } catch (e) {
    yield put(Actions.loadWorkflowFailure(e));
  }
}

const getWorkflow = (state: any) => state.workflows.data[state.workflows.selectedWorkflowId];

export function* updateWorkflowBlock() {
  try {
    const workflow = yield select(getWorkflow);
    const updated = yield call(Api.updateWorkflowBlock, workflow);
    if (updated.result.trim() === 'OK') {
      yield put(Actions.updateWorkflowSuccess(updated));
    } else {
      yield put(Actions.updateWorkflowFailure(updated.message));
    }
  } catch (e) {
    yield put(Actions.updateWorkflowFailure(e));
  }
}

export function* handleSelectBlock({type, id}: any) {
  if (id) {
    yield put(GeneralActions.sidebarSetContent({ type: 'selected-block' }));
  } else {
    yield put(GeneralActions.sidebarSetContent({ type: 'editor' }));
  }
}
